import * as actionTypes from "../../action/actiontypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  loading: false,
  getCategoryItem: [],

  getSpecialityError: [],

  specialityError: [],
  specialitySuccess: [],
  speUpdateSuccess: [],
  speUpdateErrors: [],

  deleteSuccess: [],
  deleteError: [],
};

const candidateCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MANAGE_CATEGORY_REQUEST:
      return updateObject(state, {
        loading: true,
      });

    case actionTypes.GET_MANAGE_CATEGORY_SUCCESS:
      return updateObject(state, {
        loading: false,
        getCategoryItem: action.payload,
      });

    case actionTypes.GET_MANAGE_CATEGORY_ERROR:
      return updateObject(state, {
        loading: false,
        getSpecialityError: action.payload,
      });

    case actionTypes.CREATE_MANAGE_CATEGORY_REQUEST:
      return updateObject(state, {
        loading: true,
        specialityError: "",
        specialitySuccess: "",
      });

    case actionTypes.CREATE_MANAGE_CATEGORY_SUCCESS:
      return updateObject(state, {
        loading: false,
        specialitySuccess: action.payload,
      });

    case actionTypes.CREATE_MANAGE_CATEGORY_ERROR:
      return updateObject(state, {
        loading: false,
        specialityError: action.payload,
      });

    case actionTypes.UPDATE_MANAGE_CATEGORY_REQUEST:
      return updateObject(state, {
        loading: false,
        speUpdateSuccess: "",
        speUpdateErrors: "",
      });

    case actionTypes.UPDATE_MANAGE_CATEGORY_SUCCESS:
      return updateObject(state, {
        loading: false,
        speUpdateSuccess: action.payload,
      });

    case actionTypes.UPDATE_MANAGE_CATEGORY_ERROR:
      return updateObject(state, {
        loading: false,
        speUpdateErrors: action.payload,
      });

    case actionTypes.DELETE_MANAGE_CATEGORY_REQUEST:
      return updateObject(state, {
        loading: true,
        deleteError: "",
        deleteSuccess: "",
      });

    case actionTypes.DELETE_MANAGE_CATEGORY_SUCCESS:
      return updateObject(state, {
        loading: false,
        deleteSuccess: action.payload,
      });

    case actionTypes.DELETE_MANAGE_CATEGORY_ERROR:
      return updateObject(state, {
        loading: false,
        deleteError: action?.payload,
      });

    default:
      return state;
  }
};

export default candidateCategoryReducer;
